<template>
  <div class="cat-page">

    <!-- ⭐ BREADCRUMB -->
    <BreadcrumbNav :pathArray="breadcrumbData" />

  

    <div class="layout">

  
      <!-- CONTENIDO PRINCIPAL -->
      <main class="cat-container">

        <!-- HEADER -->
        <div class="cat-header">
          <h1 class="cat-title">{{ formattedTitle }}</h1>
                    <FiltersSidebar />

          <SortDropdown />
        </div>

        <!-- LOADER INICIAL -->
        <div v-if="loading && productos.length === 0" class="loader-grid">
          <div class="loader-card" v-for="n in 8" :key="n"></div>
        </div>

        <!-- ================= OFERTAS (RESUMEN PRO) ================= -->
        <div v-else-if="$route.params.handle === 'ofertas'">
          <section
            v-for="dep in ofertasPorDepartamento"
            :key="dep.handle"
            class="cm-products-section"
          >
            <!-- Header de departamento -->
            <div class="ofertas-dep-header">
              <h2 class="cm-section-title">
                {{ dep.departamento }}
              </h2>

              <router-link
                :to="`/categoria/ofertas/${dep.handle}`"
                class="ver-todas-link"
              >
                Ver todas →
              </router-link>
            </div>

            <!-- Solo 4 productos por departamento -->
            <div class="products-grid">
              <div
                v-for="p in dep.productos.slice(0, 4)"
                :key="p.id"
                class="product-link"
              >
                <ProductCardSuper
                  :product="p"
                  @cart-updated="updateCart"
                />
              </div>
            </div>
          </section>
        </div>

        <!-- ================= CATEGORÍA NORMAL ================= -->
        <div v-else class="products-grid">
          <div
v-for="p in sortedProducts"
            :key="p.id"
            class="product-link"
          >
            <ProductCardSuper
              :product="p"
              @cart-updated="updateCart"
            />
          </div>
        </div>

        <!-- 🔥 VER MÁS (SOLO CATEGORÍAS NORMALES) -->
        <div
v-if="hasMore && !loading"
          class="ver-mas-container"
        >
          <button class="ver-mas-btn" @click="verMas">
            ➕ Ver más
          </button>
        </div>

        <!-- LOADER AL CARGAR MÁS -->
        <div v-if="loading && productos.length > 0" class="loader-mas">
          Cargando más productos…
        </div>

      </main>
    </div>

    <!-- 🔥 PANEL FILTROS MÓVIL -->
    <div
      v-if="mobileFiltersOpen"
      class="drawer-overlay"
      @click.self="mobileFiltersOpen = false"
    >
      <div class="drawer-panel">

        <div class="drawer-header">
          <h3>Filtros</h3>
          <button class="drawer-close" @click="mobileFiltersOpen = false">✕</button>
        </div>

        <div class="drawer-content">
          <FiltersSidebar
            mobile
            :defaultFilters="defaultFilters"
            :productIds="productIdsList"
            @filter-selected="mobileFiltersOpen = false; aplicarFiltro($event)"
          />
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axiosClient from "@/api/axiosClient";

import ProductCardSuper from "@/views/ProductCardSuper.vue";
import FiltersSidebar from "@/components/FiltersSidebar.vue";
import BreadcrumbNav from "@/components/BreadcrumbNav.vue";
import { useCategoryCache } from "@/components/composables/useCategoryCache";
import { useSort } from "@/components/composables/useSort";
import SortDropdown from "@/components/SortDropdown.vue";
import { useLocationStore } from "@/stores/location";

export default {
  name: "CategoriaVista",

  components: {
    ProductCardSuper,
    FiltersSidebar,
    BreadcrumbNav,
    SortDropdown
  },
data() {
  return {
    // =========================
    // PAGINACIÓN REAL
    // =========================
    cursor: null,
    hasMore: false,

    // =========================
    // CACHE (FUENTE REAL)
    // =========================
    cacheData: null,

    // =========================
    // INFO
    // =========================
    categoryTitle: "",
    ofertasPorDepartamento: [], // 👈 SIEMPRE array
    loading: true,
    isFiltering: false,

    // =========================
    // FILTROS
    // =========================
    subcategoria: "",
    marca: "",

    defaultFilters: {
      departamento: "",
      categoria: ""
    },

    // =========================
    // UI
    // =========================
    mobileFiltersOpen: false,

    // =========================
    // CACHE HANDLER
    // =========================
    categoryCache: useCategoryCache()
  };


  },
computed: {
  // =========================
  // 📍 SUCURSAL
  // =========================
  locationStore() {
    return useLocationStore();
  },

  // =========================
  // 📦 PRODUCTOS (FUENTE ÚNICA)
  // =========================
  productos() {
  if (!this.cacheData || !Array.isArray(this.cacheData.pages)) {
    return [];
  }

  const map = new Map();

  for (const page of this.cacheData.pages) {
    if (!Array.isArray(page.productos)) continue;

    for (const p of page.productos) {
      if (!p || !p.id) continue;
      map.set(p.id, p); // 🔒 deduplicación real
    }
  }

  return Array.from(map.values());
}
,
  // =========================
  // 🔀 ORDENAMIENTO
  // =========================
  sortedProducts() {
    const { sortProducts } = useSort();
    return sortProducts(this.productos);
  },

  // =========================
  // 🧾 IDS PARA FILTROS
  // =========================
  productIdsList() {
    return this.productos.map(p => p.id);
  },

  // =========================
  // 🏷️ TÍTULO FORMATEADO
  // =========================
  formattedTitle() {
    return this.categoryTitle
      ? this.categoryTitle.charAt(0).toUpperCase() +
          this.categoryTitle.slice(1).toLowerCase()
      : "";
  },

  // =========================
  // 🍞 BREADCRUMB
  // =========================
  breadcrumbData() {
    const capitalize = str =>
      str
        ?.split("-")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");

    const crumbs = [{ label: "Inicio", to: "/" }];

    if (this.defaultFilters.departamento) {
      const dep = this.defaultFilters.departamento;
      crumbs.push({
        label: capitalize(dep),
        to: `/departamento/${dep}`
      });
    }

    if (this.defaultFilters.categoria) {
      const cat = this.defaultFilters.categoria;
      crumbs.push({
        label: capitalize(cat),
        to: `/categoria/${cat}`
      });
    }

    return crumbs;
  }
}
,
watch: {
  // 🔁 CAMBIO DE RUTA (cualquier cambio relevante)
  "$route.fullPath"() {
    this.resetVista();

    const { handle, departamento } = this.$route.params;

    // 🟢 OFERTAS RESUMEN
    if (handle === "ofertas" && !departamento) {
      this.cargarOfertasResumen();
      return;
    }

    // 🟢 OFERTAS POR DEPARTAMENTO
    if (handle === "ofertas" && departamento) {
      this.cargarOfertasPorDepartamento(departamento);
      return;
    }

    // 🟢 CATEGORÍA NORMAL
    if (handle) {
      this.cargarProductos(handle);
    }
  },

  // 🔁 CAMBIO DE SUCURSAL
  "locationStore.selectedStore.id"(newVal, oldVal) {
    if (!newVal || newVal === oldVal) return;

    this.categoryCache.clearCache();
    this.resetVista();

    const { handle, departamento } = this.$route.params;

    if (handle === "ofertas" && !departamento) {
      this.cargarOfertasResumen();
      return;
    }

    if (handle === "ofertas" && departamento) {
      this.cargarOfertasPorDepartamento(departamento);
      return;
    }

    if (handle) {
      this.cargarProductos(handle);
    }
  }
}

,
async created() {
  
  this.categoryCache.clearCache();

  const { handle, departamento } = this.$route.params;

  if (!handle) {
    this.loading = false;
    return;
  }

  try {
    // 🔥 CON SUCURSAL
    if (this.locationStore.selectedStore?.id) {

      // 🟢 OFERTAS RESUMEN
      if (handle === "ofertas" && !departamento) {
        await this.cargarOfertasResumen();
        return;
      }

      // 🟢 OFERTAS POR DEPARTAMENTO
      if (handle === "ofertas" && departamento) {
        await this.cargarOfertasPorDepartamento(departamento);
        return;
      }

      // 🟢 CATEGORÍA NORMAL
      await this.cargarProductos(handle);
      return;
    }

    // 🔥 SIN SUCURSAL → CACHE (solo categorías normales)
    if (handle !== "ofertas") {
      this.cacheData = await this.categoryCache.loadCategory(handle);

      const lastPage = this.cacheData.pages.at(-1);
      this.hasMore = lastPage.hasMore;
      this.cursor = lastPage.nextCursor;

      this.defaultFilters = {
        departamento: "",
        categoria: handle.toLowerCase()
      };
    }

  } catch (e) {
    console.error("❌ Error inicial:", e);
  } finally {
    this.loading = false;
  }
}

,

  methods: {

   async cargarOfertasPorDepartamento(departamento) {
  this.loading = true;
  this.cursor = null;

  try {
    const res = await axiosClient.get(
      `/shopify/ofertas/${departamento}`,
      {
        params: {
          location_id: this.locationStore.selectedStore?.id
        }
      }
    );

    this.cacheData = {
      pages: [
        {
          productos: res.data.productos || [],
          hasMore: res.data.hasMore,
          nextCursor: res.data.nextCursor
        }
      ]
    };

    this.cursor = res.data.nextCursor;
    this.hasMore = res.data.hasMore;
    this.categoryTitle = res.data.departamento || "Ofertas";

  } catch (e) {
    console.error("❌ Error ofertas por departamento:", e);
  } finally {
    this.loading = false;
  }
}

,
    resetVista() {
  this.cacheData = null;   // 👈 ESTO ES LO CORRECTO
      this.ofertasPorDepartamento = [];
      this.cursor = null;
      this.hasMore = false;
      this.loading = true;
      this.isFiltering = false;
    },

    async aplicarFiltro({ subcategoria, marca }) {
      this.subcategoria = subcategoria || "";
      this.marca = marca || "";
      this.isFiltering = !!(this.subcategoria || this.marca);
      await this.buscarProductos();
    },
async buscarProductos() {
  this.loading = true;

  try {
    const res = await axiosClient.get("/shopify/products", {
      params: {
        subcategoria: this.subcategoria || null,
        marca: this.marca || null
      }
    });

    // 🔥 UNIFICAR MODELO CON CATEGORÍAS
    this.cacheData = {
      pages: [
        {
          productos: res.data.productos || [],
          nextCursor: res.data.nextCursor || null,
          hasMore: res.data.hasMore || false
        }
      ]
    };

    const lastPage = this.cacheData.pages.at(-1);
    this.cursor = lastPage.nextCursor;
    this.hasMore = lastPage.hasMore;

  } catch (e) {
    console.error("❌ Error en buscarProductos:", e);
  } finally {
    this.loading = false;
  }
},

async verMasOfertasPorDepartamento(departamento) {
  if (!this.hasMore) return;

  this.loading = true;

  try {
    const res = await axiosClient.get(
      `/shopify/ofertas/${departamento}`,
      {
        params: {
          location_id: this.locationStore.selectedStore?.id,
          cursor: this.cursor // 👈 ESTO ES LO IMPORTANTE
        }
      }
    );

    if (!res.data) return;

    // 🧠 agregar nueva página (NO reemplazar)
    this.cacheData.pages.push({
      productos: res.data.productos || [],
      hasMore: res.data.hasMore,
      nextCursor: res.data.nextCursor
    });

    this.cursor = res.data.nextCursor;
    this.hasMore = res.data.hasMore;

    console.log(
      "➕ OFERTAS CARGADAS:",
      res.data.productos?.length || 0
    );

  } catch (e) {
    console.error("❌ Error ver más ofertas:", e);
  } finally {
    this.loading = false;
  }
}

,
async verMas() {
  if (!this.hasMore || this.loading) return;

  this.loading = true;
  try {
    const data = await this.categoryCache.loadMore(
      this.$route.params.handle,
      {
        location_id: this.locationStore.selectedStore?.id || null
      }
    );

    if (!data) return;

    // ✅ CLAVE: nueva referencia profunda
    this.cacheData = {
      key: data.key,
      handle: data.handle,
      location_id: data.location_id,
      limit: data.limit,
      pages: data.pages.map(p => ({
        productos: [...p.productos],
        nextCursor: p.nextCursor,
        hasMore: p.hasMore
      }))
    };

    const lastPage = this.cacheData.pages.at(-1);
    this.hasMore = lastPage.hasMore;
    this.cursor = lastPage.nextCursor;
console.log(
  "TOTAL PRODUCTOS EN UI:",
  this.cacheData.pages.reduce((acc, p) => acc + p.productos.length, 0)
);

  } finally {
    this.loading = false;
  }
}





,async cargarProductos(handle) {
  if (!handle) {
    this.loading = false;
    return;
  }

  this.loading = true;

  try {
    const res = await axiosClient.get(
      `/shopify/category/${handle}`,
      {
        params: {
          location_id: this.locationStore.selectedStore?.id || null,
          cursor: this.cursor
        }
      }
    );

    // 🕵️ PRUEBA DE FUEGO: Abre la consola y mira si aquí aparece "media"
    console.log("Producto 1 recibido:", res.data.productos?.[0]);

    this.cacheData = {
      pages: [
        {
          // Mantenemos la estructura reactiva de Vue
          productos: (res.data.productos || []).map(p => ({
            ...p,
            // Nos aseguramos que media exista para que ProductCardSuper no falle
            media: p.media || [] 
          })),
          nextCursor: res.data.nextCursor,
          hasMore: res.data.hasMore
        }
      ]
    };

    const lastPage = this.cacheData.pages.at(-1);
    this.cursor = lastPage.nextCursor;
    this.hasMore = lastPage.hasMore;

    this.categoryTitle = res.data.subcategoria || handle.replace(/-/g, " ");

  } catch (e) {
    console.error("❌ Error cargando categoría:", e);
  } finally {
    this.loading = false;
  }
}

,async cargarOfertasResumen() {
  this.loading = true;

  try {
    const res = await axiosClient.get("/shopify/ofertas", {
      params: {
        location_id: this.locationStore.selectedStore?.id
      }
    });

    // ✅ USAR DIRECTO LO QUE VIENE DEL BACKEND
    this.ofertasPorDepartamento =
      res.data.ofertasPorDepartamento || [];

    this.categoryTitle = "Ofertas";
    this.hasMore = false;

    console.log("📦 OFERTAS RESUMEN:", this.ofertasPorDepartamento);

  } catch (e) {
    console.error("❌ Error cargando ofertas resumen:", e);
  } finally {
    this.loading = false;
  }
}


,
    updateCart() {
      console.log("🛒 Carrito actualizado");
    }
  }
};
</script>
<style scoped>
.product-link {
  text-decoration: none;
  color: inherit;
  display: block;
}

/* === BREADCRUMB === */
.breadcrumb {
  padding: 10px 20px;
  font-size: 0.9rem;
  color: #444;
}
.breadcrumb span {
  font-weight: bold;
}

/* === BOTÓN SOLO MÓVIL === */
.btn-mobile-filter {
  display: none;
  width: calc(100% - 40px);
  margin: 10px 20px 0 20px;
  background: #1982f8;
  color: white;
  padding: 12px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  font-weight: 700;
}

@media (max-width: 768px) {
  .btn-mobile-filter {
    display: block;
  }

  .filters-desktop {
    display: none !important;
  }
}

/* === DRAWER MOBILE === */
.drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 3000;
}

.drawer-panel {
  width: 85%;
  max-width: 380px;
  height: 100%;
  background: #fff;
  position: absolute;
  right: 0;
  top: 0;
  padding: 20px;
  overflow-y: auto;
  animation: slideInRight 0.3s ease forwards;
}

@keyframes slideInRight {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.drawer-close {
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
}

.drawer-content {
  width: 100%;
}

/* === LAYOUT DESKTOP === */
.layout {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.cat-container {
  flex: 1;
  padding: 20px;
    margin-top:50px;

}

.cat-title {
  font-size: 1.8rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #333;
}

/* === HEADER === */
.cat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* === LOADER === */
.loader-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 18px;
}

.loader-card {
  height: 210px;
  background: #eee;
  border-radius: 12px;
  animation: pulse 1.2s infinite alternate;
}

@keyframes pulse {
  from { opacity: 0.5; }
  to   { opacity: 1; }
}

/* ===============================
   GRID DE PRODUCTOS
================================ */
.products-grid {
  display: grid;
  /* Desktop por defecto */
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  align-items: stretch;
}

.product-link {
  height: 100%;
}

/* ===============================
   LOADER SHIMMER
================================ */
.loader-grid {
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
}

.loader-card {
  height: 280px;
  background: linear-gradient(
    100deg,
    #eee 30%,
    #f5f5f5 40%,
    #eee 50%
  );
  border-radius: 14px;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  from { background-position: -200px 0; }
  to   { background-position: 200px 0; }
}

/* ===============================
   VER MÁS
================================ */
.ver-mas-container {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}

.ver-mas-btn {
  background: #28a745;
  color: #fff;
  border: none;
  padding: 14px 36px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.ver-mas-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
}

.loader-mas {
  text-align: center;
  font-weight: 600;
  color: #666;
  margin: 20px 0;
}

/* ===============================
   RESPONSIVE MOBILE (SOLO AJUSTES)
================================ */
@media (max-width: 600px) {

  /* Fondo suave tipo app */
  .cat-page {
    background: #fafafa;
      margin-top:180px;

  }

  /* Quitar padding duplicado */
  .layout {
    padding: 10px;
  }

  .cat-container {
    padding: 0;
  }

  /* Header vertical */
  .cat-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
  }

  .cat-title {
    font-size: 1.4rem;
    margin-bottom: 0;
  }

  /* Grid más compacto */
  .products-grid {
  display: grid;
    /* Cambiamos 1fr por minmax(0, 1fr) para evitar que el contenido lo empuje */
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important; 
    gap: 12px; 
    padding: 0 10px; /* Un poco más de aire a los lados */
    
    /* 🔥 CRUCIAL: Evita que el grid crezca más que su padre */
    width: 100%;
    box-sizing: border-box;
  }

  /* Botón ver más más ligero */
  .ver-mas-container {
    margin: 24px 0;
  }

  .ver-mas-btn {
    width: 100%;
    max-width: 280px;
    padding: 12px 20px;
    font-size: 15px;
    border-radius: 8px;
  }

  /* Botón filtros más premium */
  .btn-mobile-filter {
    background: #111;
    border-radius: 10px;
    font-size: 15px;
    padding: 10px;
  }
}

/* Tablets */
@media (max-width: 1024px) {
  .products-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
}

/* ===============================
   VER TODAS – ESTILO PRO
================================ */

.ofertas-dep-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.ver-todas-link {
  font-size: 0.85rem;
  font-weight: 600;
  color: #e21a1a;
  text-decoration: none;

  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(226, 26, 26, 0.3);
  background: #fff;

  transition: all 0.2s ease;
}

.ver-todas-link:hover {
  background: #e21a1a;
  color: #fff;
  border-color: #e21a1a;
}

/* MOBILE */
@media (max-width: 600px) {
  .ver-todas-link {
    font-size: 0.8rem;
    padding: 5px 10px;
  }
}


/* ===============================
   SEPARADOR ELEGANTE ENTRE CATEGORÍAS
================================ */

.cm-products-section {
  position: relative;
  margin-bottom: 60px;
  padding-bottom: 40px;
}

/* Línea divisoria suave */
.cm-products-section::after {
  content: "";
  position: absolute;
  left: 10%;
  right: 10%;
  bottom: 0;

  height: 1px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(0, 0, 0, 0.15),
    transparent
  );
}

/* Quitar línea al último bloque */
.cm-products-section:last-child::after {
  display: none;
}


@media (max-width: 600px) {
  .cm-products-section {
    margin-bottom: 40px;
    padding-bottom: 28px;
  }

  .cm-products-section::after {
    left: 5%;
    right: 5%;
  }
}



</style>
